import { render, staticRenderFns } from "./new-card-modal.vue?vue&type=template&id=0939d5de&scoped=true&lang=pug&"
import script from "./new-card-modal.vue?vue&type=script&lang=js&"
export * from "./new-card-modal.vue?vue&type=script&lang=js&"
import style0 from "./new-card-modal.vue?vue&type=style&index=0&id=0939d5de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0939d5de",
  null
  
)

export default component.exports